module.exports = __webpack_public_path__ + "static/media/pic.5d85546c.png";